<template>
  <main-nav-v-2
    @logout="logout()"
  ></main-nav-v-2>
</template>

<script>
/**
 * Thin wrapper: desktop top nav is MainNavV2.
 */
import MainNavV2 from '@/components/layout/MainNavV2.vue';

export default {
  name: 'MainNav',

  components: {
    MainNavV2,
  },

  methods: {
    logout() {
      this.$emit('logout');
    },
  },
};
</script>
